module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"filters":"Filters"},"cs":{"filters":"Filtry"}}')
  delete Component.options._Ctor
}
